import React from 'react';
import './tableActions.css';

export default ({ children }) => (
  <div className="component-table-actions">{children}</div>
);
